module.exports = __webpack_public_path__ + "static/media/explosion.a9d3b34d.svg";